// @ts-check
import React from 'react';
import { VaAlert } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import {
  radioSchema,
  radioUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { FORM_10_8678 } from '../definitions/constants';

const { BENEFIT_STATUS } = FORM_10_8678;

const BENEFIT_STATUS_OPTIONS = {
  terminate: BENEFIT_STATUS.TERMINATE_OPTION,
  continue: BENEFIT_STATUS.CONTINUE_OPTION,
};
const BENEFIT_STATUS_DESCRIPTIONS = {
  terminate: BENEFIT_STATUS.TERMINATE_HINT,
};

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(BENEFIT_STATUS.TITLE, BENEFIT_STATUS.DESCRIPTION),
    'ui:order': ['electTermination', 'view:responsibilityToReportChanges'],
    electTermination: radioUI({
      title: BENEFIT_STATUS.QUESTION.label,
      hint: BENEFIT_STATUS.QUESTION.body,
      labels: BENEFIT_STATUS_OPTIONS,
      descriptions: BENEFIT_STATUS_DESCRIPTIONS,
      errorMessages: {
        required: BENEFIT_STATUS.ERROR_MESSAGE,
      },
    }),
    'view:responsibilityToReportChanges': {
      'ui:field': 'ViewField',
      'ui:description': (
        <VaAlert status="info" uswds visible>
          <h2 slot="headline" className="vads-u-font-weight--bold">
            {BENEFIT_STATUS.RESPONSIBILITY_TO_REPORT.TITLE}
          </h2>
          <p className="vads-u-margin--0">
            {BENEFIT_STATUS.RESPONSIBILITY_TO_REPORT.BODY}
          </p>
        </VaAlert>
      ),
    },
  },
  schema: {
    type: 'object',
    required: ['electTermination'],
    properties: {
      electTermination: radioSchema(Object.keys(BENEFIT_STATUS_OPTIONS)),
      'view:responsibilityToReportChanges': {
        type: 'object',
        properties: {},
      },
    },
  },
};
